module.exports = __webpack_public_path__ + "static/media/IMG_4661.4954c336.JPG";